"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var util_localization_1 = __importStar(require("@sport-thieme/util-localization"));
var Button_1 = __importDefault(require("../Button"));
var Dialog_1 = require("../Dialog");
var TextField_1 = __importDefault(require("../TextField"));
var Transitions_1 = require("../Transitions");
var core_1 = require("@material-ui/core");
var __1 = require("..");
util_localization_1.default.addTranslations('de', {
    'Type your solution': 'Lösung eingeben',
    'Solve the following problem: $0': 'Bitte löse folgende Aufgabe: $0',
    Cancel: 'Abbrechen',
});
function LevelPresentation(_a) {
    var error = _a.error, userInput = _a.userInput, equation = _a.equation, setUserInput = _a.setUserInput;
    return (jsx_runtime_1.jsxs(Dialog_1.DialogContent, { children: [jsx_runtime_1.jsx(__1.P, { children: util_localization_1.localize(templateObject_1 || (templateObject_1 = __makeTemplateObject(["Solve the following problem: ", ""], ["Solve the following problem: ", ""])), equation) }, void 0),
            jsx_runtime_1.jsx(__1.Box, __assign({ paddingTop: 2 }, { children: jsx_runtime_1.jsx(TextField_1.default, { error: error, variant: "outlined", defaultValue: userInput, label: util_localization_1.localize(templateObject_2 || (templateObject_2 = __makeTemplateObject(["Type your solution"], ["Type your solution"]))), onChange: function (e) {
                        setUserInput(e.target.value);
                    } }, void 0) }), void 0)] }, void 0));
}
function InterceptChildren(_a) {
    var intercept = _a.intercept, children = _a.children, stopPropagation = _a.stopPropagation, setCurrentEvent = _a.setCurrentEvent, setCurrentFunction = _a.setCurrentFunction, setShowDialog = _a.setShowDialog, forwardedRef = _a.forwardedRef;
    if (typeof intercept === 'string') {
        intercept = [intercept];
    }
    else {
        intercept = intercept !== null && intercept !== void 0 ? intercept : ['onClick'];
    }
    return (jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: react_1.default.Children.map(children, function (child) {
            var interceptions = intercept.reduce(function (result, func) {
                if (child.props[func]) {
                    var some = function (event) {
                        event === null || event === void 0 ? void 0 : event.persist();
                        if (event && stopPropagation && event.stopPropagation) {
                            event.stopPropagation();
                        }
                        setCurrentFunction(function () { return child.props[func]; });
                        setCurrentEvent(function () { return event; });
                        setShowDialog(function () { return true; });
                    };
                    result[func] = some;
                }
                return result;
            }, {});
            return react_1.default.cloneElement(child, __assign(__assign({}, interceptions), { ref: forwardedRef }));
        }) }, void 0));
}
function ConfirmationDialog(_a) {
    var closeDialog = _a.closeDialog, title = _a.title, question = _a.question, level = _a.level, userInput = _a.userInput, error = _a.error, isValid = _a.isValid, confirmationTitle = _a.confirmationTitle, equation = _a.equation, setUserInput = _a.setUserInput, cancelTitle = _a.cancelTitle, onCancel = _a.onCancel, handleConfirmation = _a.handleConfirmation;
    if (title === undefined && question === undefined) {
        title = util_localization_1.localize(templateObject_3 || (templateObject_3 = __makeTemplateObject(["Are you sure?"], ["Are you sure?"])));
    }
    return (jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: jsx_runtime_1.jsxs(Dialog_1.Dialog, __assign({ open: true, onClose: function () { return closeDialog; }, TransitionComponent: Transitions_1.Slide }, { children: [title && jsx_runtime_1.jsx(Dialog_1.DialogTitle, { children: title }, void 0),
                question && (jsx_runtime_1.jsx(Dialog_1.DialogContent, { children: jsx_runtime_1.jsx(Dialog_1.DialogContentText, __assign({ id: "alert-dialog-slide-description" }, { children: question }), void 0) }, void 0)),
                level === 'hard' && (jsx_runtime_1.jsx(LevelPresentation, { userInput: userInput, error: error, equation: equation, setUserInput: setUserInput }, void 0)),
                jsx_runtime_1.jsxs(core_1.DialogActions, { children: [jsx_runtime_1.jsx(Button_1.default, { label: cancelTitle, color: "default", variant: "text", onClick: function (event) {
                                onCancel === null || onCancel === void 0 ? void 0 : onCancel(event);
                                closeDialog();
                            } }, void 0),
                        jsx_runtime_1.jsx(Button_1.default, { autoFocus: true, label: confirmationTitle, variant: "contained", color: "primary", onClick: handleConfirmation, disabled: isValid === false }, void 0)] }, void 0)] }), void 0) }, void 0));
}
var Confirmation = react_1.forwardRef(function Confirmation(_a, ref) {
    var _b = _a.cancelTitle, cancelTitle = _b === void 0 ? util_localization_1.localize(templateObject_4 || (templateObject_4 = __makeTemplateObject(["Cancel"], ["Cancel"]))) : _b, _c = _a.confirmationTitle, confirmationTitle = _c === void 0 ? 'Ok' : _c, _d = _a.intercept, intercept = _d === void 0 ? 'onClick' : _d, _e = _a.level, level = _e === void 0 ? 'normal' : _e, _f = _a.stopPropagation, stopPropagation = _f === void 0 ? false : _f, title = _a.title, onCancel = _a.onCancel, question = _a.question, children = _a.children;
    var _g = react_1.useState(false), showDialog = _g[0], setShowDialog = _g[1];
    var _h = react_1.useState(null), currentFunction = _h[0], setCurrentFunction = _h[1];
    var _j = react_1.useState(null), currentEvent = _j[0], setCurrentEvent = _j[1];
    var _k = react_1.useState(''), userInput = _k[0], setUserInput = _k[1];
    var _l = react_1.useState(false), error = _l[0], setError = _l[1];
    var leftNumber = react_1.useMemo(function () { return Math.floor(Math.random() * 100 + 1); }, []);
    var rightNumber = react_1.useMemo(function () { return Math.floor(Math.random() * 100 + 1); }, []);
    var operator = react_1.useMemo(function () { return ['+', '-', '*'][Math.floor(Math.random() * 3)]; }, []);
    function closeDialog() {
        setShowDialog(false);
    }
    function validateLevel() {
        if (level === 'hard') {
            var userNumber = parseInt(userInput, 10);
            switch (operator) {
                case '+':
                    return userNumber === leftNumber + rightNumber;
                case '-':
                    return userNumber === leftNumber - rightNumber;
                case '*':
                    return userNumber === leftNumber * rightNumber;
            }
        }
        return true;
    }
    function handleConfirmation(event) {
        if (event && stopPropagation && event.stopPropagation) {
            event.stopPropagation();
        }
        if (validateLevel()) {
            currentFunction === null || currentFunction === void 0 ? void 0 : currentFunction(currentEvent);
            closeDialog();
        }
        else {
            setError(true);
        }
    }
    var confirmationDialogProps = {
        closeDialog: closeDialog,
        title: title,
        question: question,
        level: level,
        userInput: userInput,
        error: error,
        isValid: validateLevel(),
        equation: leftNumber + " " + operator + " " + rightNumber,
        confirmationTitle: confirmationTitle,
        setUserInput: setUserInput,
        cancelTitle: cancelTitle,
        onCancel: onCancel,
        handleConfirmation: handleConfirmation,
    };
    var interceptChildrenProps = {
        children: children,
        stopPropagation: stopPropagation,
        intercept: intercept,
        setCurrentEvent: setCurrentEvent,
        setCurrentFunction: setCurrentFunction,
        setShowDialog: setShowDialog,
    };
    return (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [jsx_runtime_1.jsx(InterceptChildren, __assign({ forwardedRef: ref }, interceptChildrenProps), void 0),
            showDialog ? jsx_runtime_1.jsx(ConfirmationDialog, __assign({}, confirmationDialogProps), void 0) : ''] }, void 0));
});
exports.default = Confirmation;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=Confirmation.js.map